import { ApiPath } from "enums";
import { Get, Put } from "utils";

export const getOrderSummaryListApi = async (query) => {
  const res = await Get(`${ApiPath.OrderSummary}`, query);
  return res.data;
};

export const getOrderSummaryByIdApi = async (query) => {
  const res = await Get(`${ApiPath.OrderSummary}/${query?.id}`, query);
  return res.data;
};

export const updateOrderSummaryByIdApi = async (query) => {
  const res = await Put(`${ApiPath.OrderSummary}/${query?.id}`, query);
  return res.data;
};
